import React from 'react';
import SvgArrowLgLeft from './SvgArrowLgLeft';
import SvgArrowLgRight from './SvgArrowLgRight';

import * as styles from './arrow-lg-button.module.css';

interface Props {
    className?: string;
    strokeColor: string;
    direction: 'right' | 'left';
    handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    'aria-label'?: string;
}

const ArrowLgButton: React.FC<Props> = ({
    className,
    strokeColor,
    direction,
    handleClick,
    'aria-label': ariaLabel,
}) => {
    return (
        <button
            type="button"
            className={`${className} ${styles.button}`}
            onClick={handleClick}
            aria-label={
                ariaLabel || (direction === 'left' ? 'Previous' : 'Next')
            }
        >
            {direction === 'right' && (
                <SvgArrowLgRight strokeColor={strokeColor} />
            )}

            {direction === 'left' && (
                <SvgArrowLgLeft strokeColor={strokeColor} />
            )}
        </button>
    );
};

export default ArrowLgButton;
